import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_VEHICLES_DOCUMENTS_TYPES_DATA, DELETE_VEHICLES_DOCUMENTS_TYPE } from "./actionTypes";
import {
  fetchVehiclesDocumentsTypesSuccess,
  fetchVehiclesDocumentsTypesFailure,
  fetchVehiclesDocumentsTypesData,
  deleteVehiclesDocumentsTypeSuccess,
  deleteVehiclesDocumentsTypeFailure,
} from "./actions";

function* fetchVehiclesDocumentsTypesDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/vehicles-documents-types",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchVehiclesDocumentsTypesSuccess(response.data));
  } catch (error) {
    yield put(fetchVehiclesDocumentsTypesFailure(error.message));
  }
}

function* deleteVehiclesDocumentsTypeSaga(action) {
  try {
    const token = localStorage.getItem("authToken");
    yield call(
      axios.delete,
      process.env.REACT_APP_WEB_APP_URL + "/api/web/vehicles-documents-types/" + action.payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    yield put(deleteVehiclesDocumentsTypeSuccess());
    yield put(fetchVehiclesDocumentsTypesData());
  } catch (error) {
    yield put(deleteVehiclesDocumentsTypeFailure(error.response?.data?.message || error.message));
  }
}

export default function* vehiclesDocumentsTypesSaga() {
  yield takeEvery(FETCH_VEHICLES_DOCUMENTS_TYPES_DATA, fetchVehiclesDocumentsTypesDataSaga);
  yield takeEvery(DELETE_VEHICLES_DOCUMENTS_TYPE, deleteVehiclesDocumentsTypeSaga);
}
